import React, { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";

export default function ChangePin() {
  const { checkAuth, logout } = useAuth();
  const [pin, setPin] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!/^\d{4,}$/.test(pin)) { toast.error("PIN must be at least 4 digits"); return; }
    if (pin !== confirm) { toast.error("Those PINs don't match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-pin", { new_pin: pin });
      toast.success("Your new PIN is set!");
      await checkAuth();
    } catch (err) { toast.error(err.response?.data?.detail || "Something went wrong"); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-md bg-white rounded-3xl border border-gray-100 p-8" data-testid="change-pin-page">
        <div className="flex items-center gap-2 text-teal-dark"><KeyRound className="w-5 h-5" /><span className="font-semibold">Choose your own PIN</span></div>
        <h2 className="font-head text-2xl font-bold mt-2">Welcome! Let's secure your account</h2>
        <p className="text-muted-foreground mt-1.5">You signed in with a temporary PIN. Pick a new secret PIN only you know.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-semibold">New PIN (min 4 digits)</label>
            <Input data-testid="change-pin-new" type="password" inputMode="numeric" value={pin} onChange={(e) => setPin(e.target.value)} className="mt-1.5 rounded-xl" placeholder="••••" autoFocus />
          </div>
          <div>
            <label className="text-sm font-semibold">Confirm PIN</label>
            <Input data-testid="change-pin-confirm" type="password" inputMode="numeric" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5 rounded-xl" />
          </div>
          <button type="submit" data-testid="change-pin-submit" disabled={busy} className="w-full bg-teal hover:bg-teal-dark text-white rounded-full py-3.5 font-semibold transition-colors">{busy ? "Saving…" : "Save my PIN"}</button>
        </form>
        <button onClick={logout} className="mt-4 text-sm text-muted-foreground hover:underline">Sign out</button>
      </div>
    </div>
  );
}
